(function ($) {
    document.addEventListener('DOMContentLoaded', function () {
        const product__description = document.querySelector('#product_description');
        let description_slider__wrapper = document.querySelector('.description-slider__wrapper');
        let productDescription__slider = product__description ? product__description.querySelector('.swiper') : null;
        var swipeHandImg = document.querySelector('.sliderSwipeHandImage');
        let productDescription__swiper_speed = 1200;
        let productDescription__swiper = null;
        let maxArr = [];

        window.addEventListener('load', productSliderHandler);

        function productSliderHandler() {
            if (product__description) {
                product__description.style.display = "block";
    
                if (productDescription__slider) {
                    const sliderItems = productDescription__slider.querySelectorAll('.swiper-slide');

                    if (sliderItems.length > 1) {
                        window.addEventListener('load', () => loadResizeHandler(sliderItems));
                        window.addEventListener('resize', () => loadResizeHandler(sliderItems));
    
                        productDescription__swiper = new Swiper(productDescription__slider, {
                            direction: "horizontal",
                            slidesPerView: 1,
                            speed: productDescription__swiper_speed,
                            effect: 'fade',
                            allowTouchMove: false,
                            noSwiping: false,
                            fadeEffect: {
                                crossFade: true
                            },
                            on: {
                                init: () => {
                                    loadResizeHandler(sliderItems);

                                    let wrapper = document.querySelector('.description-slider-wrapper');
                                    if (wrapper) {
                                        wrapper.classList.add('init_slider');
                                    }
                                }
                            },
                            preventInteractionOnTransition: true,
                            pagination: {
                                el: "#product_description .swiper-pagination",
                                clickable: true,
                            },
                            navigation: {
                                nextEl: '#product_description .slider-button-next',
                                prevEl: '#product_description .slider-button-prev',
                            },
                            breakpoints: {
                                0: {
                                    allowTouchMove: true,
                                    noSwiping: true,
                                },
                                992: {
                                    allowTouchMove: false,
                                    noSwiping: false,
                                }
                            }
                        });
    
                        const productDescription_image = document.querySelectorAll('.description-slider__item-image');
                        if (productDescription_image.length) {
                            for (let i = 0; i < productDescription_image.length; i++) {
                                productDescription_image[i].addEventListener('click', productsImageHandler);
                            }
                        }
    
                        let prevSlide = 0;
                        if (productDescription__swiper !== null) {
                            setTimeout(() => {
                                let firstSlide = productDescription__swiper.slides[0];
                                firstSlide ? firstSlide.classList.add('transitionEnd') : null;
                            }, 100);
                        }
    
                        productDescription__swiper.on('slideChange', function (slider) {
                            setTimeout(() => {
    
                                if (slider.activeIndex === slider.slides.length - 1) {
                                    if (!swipeHandImg.classList.contains('transparent')) {
                                        swipeHandImg.classList.add('transparent');
                                    }
                                }
        
                                for (let i = 0; i < slider.slides.length; i++) {
                                    slider.slides[i].classList.remove('transitionEnd');
                                }
        
                                slider.slides[slider.activeIndex].classList.add('transitionEnd');
                            }, productDescription__swiper_speed);
    
                            prevSlide = slider.activeIndex;
                        });
                    }
    
                } else {
                    let wrapper = document.querySelector('.description-slider-wrapper');
                    if (wrapper) {
                        wrapper.classList.add('init_slider')
                    }
                }
            }
        }
        
        function productsImageHandler() {
            if (productDescription__swiper != null) {
                productDescription__swiper.slideNext(productDescription__swiper_speed);
            }
        }

        function loadResizeHandler(sliderItems) {
            checkAnchorElem();

            if (window.innerWidth > 991) {
                changeHeightOfBlocks(sliderItems)
            } else {
                changeHeightOfBlocksForMobile();
            }
        }

        function checkAnchorElem() {
            if (window.innerWidth > 991) {
                anchor_elem = product__description
            } else {
                anchor_elem = description_slider__wrapper
            }
        }

        function changeHeightOfBlocks(sliderItems) {
            for (let i = 0; i < sliderItems.length; i++) {
                const image = sliderItems[i].querySelector('.description-slider__item-image');
                const content = sliderItems[i].querySelector('.description-slider__item-content');

                maxArr.push(Math.max(image.clientHeight, content.clientHeight));
            }

            if (productDescription__slider !== null) {
                productDescription__slider.style.maxHeight = Math.max(...maxArr) + 'px';
            }
        }

        function changeHeightOfBlocksForMobile() {
            productDescription__slider.style.maxHeight = 'unset';
        }













        

        const feedback_slider = document.querySelector('.feedback-slider__swiper');
        if (feedback_slider) {
            const feedback_swiper = new Swiper(feedback_slider, {
                direction: "horizontal",
                slidesPerView: 1,
                loop: true,
                speed: 1200,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                navigation: {
                    nextEl: '.feedback-slider__wrap .slider-button-next',
                    prevEl: '.feedback-slider__wrap .slider-button-prev',
                },
                breakpoints: {
                    0: {
                        speed: productDescription__swiper_speed * 0.5,
                    },
                    992: {
                        speed: productDescription__swiper_speed,
                    }
                }
            });

            const feedback__images = document.querySelectorAll('.feedback-slider__item-image--circle_link');
            for (let i = 0; i < feedback__images.length; i++) {
                feedback__images[i].addEventListener('click', function (e) {
                    e.preventDefault();
                    feedback_swiper.slideNext();
                });
            }
        }

        window.addEventListener('load', function () {
            const prices_section = document.querySelector('section.prices');

            if (prices_section) {
                const text = prices_section.querySelector('.prices__heading-text');
                const info = prices_section.querySelector('.prices__info');

                setTimeout(() => {
                    text.style.padding = info.style.padding = '40px';
                }, 100);

                setTimeout(() => {
                    text.removeAttribute('style');
                    info.removeAttribute('style');
                }, 200);
            }
        });

        const prices_icons = document.querySelectorAll('.prices__list-item--icon');
        if (prices_icons.length) {

            for (let i = 0; i < prices_icons.length; i++) {
                const _self = prices_icons[i];

                $(document).on('mouseup', function (e) {
                    let container = $(_self);

                    if (container.has(e.target).length !== 0) {
                        if (!container.hasClass('open')) {
                            container.addClass('open');
                        } else {
                            container.removeClass('open');
                        }
                    } else {
                        container.removeClass('open');
                    }

                });
            }

        }

        /**
         * Puzzle: TwoIcons
         */
        window.addEventListener('load', puzzleTwoIconsLineCalculate);
        window.addEventListener('resize', puzzleTwoIconsLineCalculate);

        function puzzleTwoIconsLineCalculate() {
            const twoIcons = document.querySelector('.puzzle-twoIcons');
            if (twoIcons && window.innerWidth > 1439) {
                const icons = twoIcons.querySelectorAll('.puzzle__icon');

                if (icons) {
                    const iconsWrapper = twoIcons.querySelector('.puzzle__icons');
                    const after = icons[0].querySelector('.after');

                    let offset = iconsWrapper.clientWidth - 136 - 40 - 68;

                    after.style.width = offset + 'px';
                }
            }
        }

        /**
         * Puzzle: NineIcons
         */
        window.addEventListener('load', puzzleNineIconsLineCalculate);
        window.addEventListener('resize', puzzleNineIconsLineCalculate);

        function puzzleNineIconsLineCalculate() {
            const nineIcons = document.querySelector('.puzzle-nineIcons');
            const icons = nineIcons ? nineIcons.querySelectorAll('.puzzle__icon') : null;

            if (nineIcons && window.innerWidth > 1439) {
                if (icons) {
                    const iconsText = nineIcons.querySelector('.puzzle__text');
                    const before = icons[0].querySelector('.before');
                    const after = icons[0].querySelector('.after');

                    let afterOffset = $(icons[0]).offset().left;
                    let textOffset = $(iconsText).offset().left + iconsText.clientWidth - 80;

                    let value = afterOffset - textOffset > 65 ? afterOffset - textOffset : 65;

                    setTimeout(() => {
                        before.style.left = "-" + value + 'px';
                        after.style.width = value + 6 + 'px';
                    }, 25)
                }
            } else if (window.innerWidth < 1440 && window.innerWidth > 991) {
                if (icons) {
                    const before = icons[0].querySelector('.before');
                    const after = icons[0].querySelector('.after');
                    before.style.left = "-" + 65 + 'px';
                    after.style.width = 65 + 6 + 'px';
                }
            }
        }
    });
})(jQuery);
